import { ComponentPropsWithoutRef, ReactNode } from 'react';

import classNames from 'classnames';

type Props = ComponentPropsWithoutRef<'li'> & {
  isLastItem: boolean;
  label: ReactNode;
  description: ReactNode;
  buttons: ReactNode;
  counter?: ReactNode;
  isDisabled?: boolean;
};

export const ListItem = ({
  label,
  description,
  isLastItem,
  buttons,
  counter,
  isDisabled = false,
  ...props
}: Props) => {
  return (
    <li
      className={classNames(
        'md:min-h-[4.5rem] ',
        !isLastItem && 'border-b border-base-border-medium',
      )}
      {...props}
    >
      <div className="flex w-full items-center gap-3">
        <div className="flex w-full md:items-center py-5 gap-4 xl:gap-3 max-md:flex-col">
          <p className="flex flex-col gap-1 xl:gap-0.5">
            <span
              className={classNames(
                'text-sm font-semibold xl:text-base text-base-text-primary',
                isDisabled && 'text-base-text-quaternary',
              )}
            >
              {label}
            </span>
            {description && (
              <span
                className={classNames(
                  'text-2xs leading-3 xl:text-xs font-medium text-base-text-tertiary',
                )}
              >
                {description}
              </span>
            )}
          </p>
          <div
            className={classNames(
              'flex gap-3 [&>*]:w-full md:[&>*]:w-[10rem] md:ml-auto max-sm:flex-col',
            )}
          >
            {buttons}
          </div>
        </div>
        <div>{counter}</div>
      </div>
    </li>
  );
};
